
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quoto/privacy-policy",
      function () {
        return require("private-next-pages/quoto/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quoto/privacy-policy"])
      });
    }
  